/* eslint-disable jsx-a11y/anchor-is-valid */
import { ToastContainer } from 'react-toastify';
import Spinner from '../../Spinner/spinner';
import { useEffect, useState } from 'react';
import moment from 'moment/moment';
import { getWebhookList } from '../../../Context/api';
import axios from 'axios';
import { statusCodes } from '../../../Constants/generalConfig';
import PaginationCom from '../../Pagination/pagination';


const WebhookList = () => {
    const [listData, setListData] = useState([]);
    const [listDataView, setListDataView] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [spinner, setSpinner] = useState(false);
    const pageSize = 10

    useEffect(() => {
        getList(currentPage);
    }, [currentPage]);

    const getList = async (page) => {
        setSpinner(true)
        try {
            const payload = {
                page,
                count: pageSize,
            };
            axios.post(getWebhookList(), payload).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    setListData(resp?.data?.data || []);
                    setTotalCount(resp?.data?.totalCount || 0);
                }
                else {
                    setSpinner(false)
                }
            })
            setSpinner(false)
        } catch (err) {
            setListData([]);
            setSpinner(false)
        }
    };

    const totalPages = Math.ceil(totalCount / pageSize);

    const renderPagination = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(i)}>
                        {i}
                    </button>
                </li>
            );
        }
        return pages;
    };
    return (
        <section>
            {spinner ? <Spinner /> : null}
            <ToastContainer />
            <div className="container-fluid mt-5">
                <table className="table table-bordered table-striped">
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: '5%' }}>#</th>
                            <th style={{ width: '20%' }}>Date</th>
                            <th>Data</th>
                            <th style={{ width: '10%' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listData.length > 0 ? (
                            listData.map((item, index) => {
                                const text = JSON.stringify(item);
                                const displayText = text.slice(0, 100);
                                return (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td>{moment(item?.createdAt).format('lll')}</td>
                                        <td>{displayText}...</td>
                                        <td>
                                            {text.length > 100 && (
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    onClick={() => setListDataView(item)}
                                                    style={{
                                                        color: 'blue',
                                                        cursor: 'pointer',
                                                        background: 'none',
                                                        border: 'none',
                                                        padding: 0,
                                                    }}
                                                >
                                                    Read More
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No Record Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                {listData.length > 0 &&


                    <div className='w-100 d-flex justify-content-center mt-5 pb-3'>
                        <PaginationCom setpage={setCurrentPage} count={Math.ceil(totalCount / pageSize)} page={currentPage} />
                    </div>
                }
                {/* <nav className="d-flex justify-content-center">
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
                                    Previous
                                </button>
                            </li>
                            {renderPagination()}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav> */}


                {/*Read More Modal */}
                <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                            </div>
                            <pre className='p-2' style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {JSON.stringify(listDataView, null, 2)}
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WebhookList


